import React, { FC, useMemo } from 'react';
import { Container, Box, Button } from '@mui/material';
import StyledBox from 'views/rebranded-module/information-module/FaqsViewV2/components/FaqsHeaderSection/FaqsHeaderSection.styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography500 from 'views/common/components/UI/Typography500';
import PATHS from 'lib/navigation/paths';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  Typography700,
  BreadcrumbsV2,
} from 'views/rebranded-module/common/components';
import { PAGE_STATES } from 'views/rebranded-module/information-module/FaqsViewV2/utils/constants';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { FaqsHeaderProps } from 'views/rebranded-module/information-module/FaqsViewV2/components/FaqsHeaderSection/FaqsHeaderSection.types';

const FaqsHeaderSection: FC<FaqsHeaderProps> = (props) => {
  const {
    pageState,
    handleBackButtonClick,
    typeObject,
    handleBreadCrumbsClick,
  } = props;
  const content = useContent('FAQSPage');
  const breadcrumbsObject = useMemo(
    () =>
      !typeObject?.pathIdentifier
        ? {
            links: [
              {
                text: content.eagleRiderLabel,
                path: PATHS.home(),
              },
              {
                text: content.information,
                path: PATHS.information(),
              },
              {
                text: content.faqs,
              },
            ],
          }
        : {
            links: [
              {
                text: content.eagleRiderLabel,
                path: PATHS.home(),
              },
              {
                text: content.information,
                path: PATHS.information(),
              },
              {
                text: content.faqs,
                path: PATHS.faqs.index(),
                onClick: handleBreadCrumbsClick,
              },
              {
                text: typeObject.label,
              },
            ],
          },
    [typeObject?.pathIdentifier],
  );

  return (
    <StyledBox>
      <Container maxWidth="xl" className="FHSConatiner">
        {pageState === PAGE_STATES.SEARCH ? (
          <Button
            startIcon={<ArrowBackIcon />}
            color="secondary"
            size="large"
            className="FHSBackBtn"
            component={NavigatorLink}
            href={PATHS.faqs.index()}
            onClick={handleBackButtonClick}>
            {content.back}
          </Button>
        ) : (
          <Box className="FHSTitleContainer">
            <BreadcrumbsV2 data={breadcrumbsObject} />
            <Typography700 component="h1" variant="h1">
              {content.pageTitle}
            </Typography700>
            <Typography500
              component="p"
              variant="body2"
              className="FHSDescription">
              {content.pageDescription}
            </Typography500>
          </Box>
        )}
      </Container>
    </StyledBox>
  );
};

export { FaqsHeaderSection };
